import { useEffect, useState } from 'react'

export const getSectionIdFromHash = (): string | null => {
  if (typeof window === 'undefined') {
    return null
  }

  const id = window.location.hash.replace(/^#/, '')

  return id || null
}

/** Активная секция только из URL-hash (клик / deep-link), без scroll-spy. */
export const useSectionHash = () => {
  const [sectionId, setSectionId] = useState<string | null>(null)

  useEffect(() => {
    const sync = () => {
      setSectionId(getSectionIdFromHash())
    }

    sync()

    window.addEventListener('hashchange', sync)
    window.addEventListener('popstate', sync)

    return () => {
      window.removeEventListener('hashchange', sync)
      window.removeEventListener('popstate', sync)
    }
  }, [])

  return sectionId
}
